<template src= "./index.html"></template>

<script>
import Vue from 'vue'

import isEmpty from 'lodash/isEmpty'
import { parseISO, format } from 'date-fns'
import optionData from '@/optionData/data'
import {ko} from 'vuejs-datepicker/dist/locale'
import { Tag } from 'element-ui'
import moment from 'moment'
import agTableComp from '@/optionData/agTableComp'

export const BtnSelect = Vue.extend({
  name : 'btnSelect',
  template: `
      <vs-button class="btnSmall" @click="btnClickedHandler()" :color="color" type="filled">{{text}}</vs-button>
    `,
  data(){
    return{
      title : '',
      text : '',
      color : 'success'
    }
  },
  created(){
    this.title = this.params.colDef.headerName
    this.text  = this.params.text ? this.params.text : '선택'
    this.color = this.params.text == '반려' ? 'danger' : this.params.text == "지급처리" ? '' : 'success'
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export const MultiSelect = Vue.extend({
  name : 'multiSelect',
  template: `
      <div>
      <vs-button class="btnSmall" @click="btnClickedHandler()" color="primary" type="filled">지급</vs-button>
      <vs-button class="btnSmall" @click="btnClickedHandler2()" color="danger" type="filled">반려</vs-button>
      </div>
    `,
  data(){
    return{
      title : '',
      text : '',
      color : 'success'
    }
  },
  created(){
    this.title = this.params.colDef.headerName
    this.text  = this.params.text ? this.params.text : '선택'
    this.color = this.params.text == '반려' ? 'danger' : this.params.text == "지급처리" ? '' : 'success'
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    },
    btnClickedHandler2() {
      this.params.clicked2(this.params.data);
    }

  },
});

export const TextRender = Vue.extend({
  name : 'textRender',
  template: `
     <span>{{text}}</span>
    `,
  data(){
    return{
      title : '',
      text : ''
    }
  },
  created(){
    this.title = this.params.colDef.headerName
    this.text  = this.params.text ? this.params.text : '선택'
    
  },
  methods: {
   
  },
});


export default {
  name: 'withdrawal',
  
  data () {
    return {
      ko : ko,
      optionData : optionData,
      

      keywordOption :[
          {value: 'user_email', label:'Email ID'},
          {value: 'user_name', label:'권리자명'},
          {value: 'user_company', label: '회사명'},
          {value: 'ref_code',label: '출금신청번호',},
      ],
      keywordType :null,
      
      keyword : '',
      state : null,
      payment_method :null,
      currency : null,
      entity : null,
      role :null,
      startDate :null,
      endDate : null,
      dateType :'created_at' ,

      dateOption : [
          {value: 'created_at',label: '신청일',},
          {value: 'fulfillment_timestamp',label: '처리완료일',},
      ],
      entity_tax_exemption : null,
      entity_tax_exemptionOption : [
          {value:'false',label : '과세'},
          {value:'true', label : '면세'},
      ],
      total : 0,
      filtered:0,
      page: {
          pageSize : 10,
          currentPage: 1,                       // 현재 페이지
          totalPage: 0,                         // 총 페이지수
      },          
      gridOptions :{ // 테이플 옵션
        // onRowClicked: (event)=>{
        //       this.viewDetail(event)
        // },
        context: {
          componentParent: this
        },
        frameworkComponents : {
          btnSelect : BtnSelect,
          textRender : TextRender,
          multiSelect : MultiSelect,
          tooltip : agTableComp.tooltip
        }
      },
      defaultColDef: {
          sortable: false,
          editable: false,
          resizable: true,
          suppressMenu: false,
          rowSelection:'single',
          suppressPaste: true
      },
      columnDefs: [
          // amount_after_tax: 1199000
          // amount_before_tax: 1090000
          // created_at: "2020-11-04T02:54:41.588Z"
          // currency: "krw"
          // fulfillment_timestamp: "2020-11-04T02:55:00.041Z"
          // id: 12
          // ref_code: "W201104-4TCGU8L"
          // rejected_reason: null
          // state: "fulfilled"
          // tax_amount: 109000
          // tax_invoice_checked: true
          // tax_invoice_timestamp: "2020-11-10T15:00:00.000Z"
          // tax_rate: 10
          // updated_at: "2020-11-04T02:55:00.041Z"
          // user_company: "주식회사 사운드리퍼블리카"
          // user_country: "kr"
          // user_currency: "krw"
          // user_email: "dist_kr@soundrepublica.com"
          // user_entity: "corporation"
          // user_entity_tax_exemption: false
          // user_family_name: null
          // user_given_name: "노건식, 김태윤"
          // user_id: 628
          // user_name: "노건식, 김태윤"
          // user_payment_method: "kr_banktransfer"
          // user_role: "licensor"
          {headerName: '신청일시',      field: 'created_at',     filter: false,width: 180,
          cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
          }},
          
          {headerName: '진행상태',      field: 'state',     filter: false,width: 100,cellRenderer: (data) => {
            let dd = {
              requested: '출금신청',
              fulfilled: '지급완료',
              rejected :'반려완료'
            }
            let color = {
                requested : '#262c49',//'접수', 
                fulfilled : '#24c1a0',//'발매 완료', 
                rejected : '#ea5455',//'반려' 
            }
            return `
              <div class="con-vs-chip vs-chip-primary con-color" 
              style="
                  background-color: ${color[data.value]} !important;
                  color:#fff;
                  line-height:1;
                  padding:3px 5px;
                  margin:13px 0; 
                  font-size:13px;
                  min-width:50px;
              ">
                  <span style="margin:0" class="text-chip vs-chip--text">
                  ${dd[data.value]}
              </span><!----></div>`
          }},
          {headerName: '사업자구분',      field: 'user_entity',     filter: false,width: 120, cellRenderer: (data) => {
            let dd = {
              corporation : '사업자', 
              individual : '개인', 
            }
            return dd[data.value]
          }},
          
          {headerName: '권리자명(성 이름)',      field: 'user_family_name',     filter: false,width: 200,
          cellRenderer: (data) => {
            return (data.data.user_family_name ? data.data.user_family_name  :'' )+' ' + (data.data.user_given_name ? data.data.user_given_name : '')
          }},
          {headerName: '회사명',      field: 'user_company',     filter: false,width: 200},
          {headerName: '출금신청금액',      field: 'amount_before_tax',     filter: false,width: 180,cellRenderer: (data) => {
            let dd = {
              eur : ' €', 
              usd : ' $', 
              krw : ' 원', 
            }
            return this.numberFormat(data.value)+ dd[data.data.user_currency];;
          }},
          {headerName: '적용세율',      field: 'tax_rate',     filter: false,width: 170, cellRenderer: (data) => {
            let dd = data.value + '%'
              if(data.data.user_entity_tax_exemption ){
                dd = '면세사업자' 
              }
            return dd
          }},
          {headerName: '예상 적용세액',      field: 'tax_amount',     filter: false,width: 200,cellRenderer: (data) => {
            let dd = {
              eur : ' €', 
              usd : ' $', 
              krw : ' 원', 
            }
            return this.numberFormat(data.value) + dd[data.data.user_currency];;
          }},
          {headerName: '실지급예상금액',      field: 'amount_after_tax',     filter: false,width: 200,cellRenderer: (data) => {
            let dd = {
              eur : ' €', 
              usd : ' $', 
              krw : ' 원', 
            }
            return this.numberFormat(data.value)+ dd[data.data.user_currency];;
          }},
          {headerName: '계산서 발행일',      field: '',     filter: false,width: 200,
          cellRendererParams: {
            clicked: function(data) {
              this.context.componentParent.setInvoice(data)
              //this.context.componentParent.closeModal('licensor')
            }
          },
          cellRendererSelector: (data) => {
            console.log(data)
            if(data.data.user_country.toUpperCase() == 'KR' && data.data.user_entity == 'individual'){
              return { 
                  component: 'textRender',
                  params: {
                    ...data.data,
                    text: '개인'
                  }
                }
            }else{
              if(data.data['tax_invoice_checked']){
                return { 
                  component: 'textRender',
                  params: {
                    ...data.data,
                    text: this.fixDate(data.data.tax_invoice_timestamp)
                  }
                }
                  
              }else if(data.data.state == 'rejected'){
                return { 
                  component: 'textRender',
                  params: {
                    ...data.data,
                    text: '반려'
                  }
                }
              }else{
                return { 
                  component: 'btnSelect',
                  params: {
                    ...data.data,
                    text: '계산서 확인'
                  }
                }
              }
            }
          }},
          {headerName: '처리완료일',      field: 'fulfillment_timestamp',     filter: false,width: 150,
          cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
          }},
          {headerName: '이메일',      field: 'user_email',     filter: false,width: 270},
          {headerName: '정산화폐',      field: 'user_currency',     filter: false,width: 100, cellRenderer: (data) => {
            let dd = data.value.toUpperCase()
            return dd
          }},
          {headerName: '거주국가',      field: 'user_country',     filter: false,width: 100, cellRenderer: (data) => {
              let dd = data.value.toUpperCase()
            return dd
          }},
          {headerName: '지급방법',      field: 'user_payment_method',     filter: false,width: 100,cellRenderer: (data) => {
            let dd = {
              kr_banktransfer : " 계좌이체",
              intl_banktransfer : "WireTransfer",
              paypal : "Paypal",
              payoneer : "Payoneer",
            }
            return dd[data.value]
          }},
          {headerName: '사용자구분',      field: 'user_role',     filter: false,width: 100,cellRenderer: (data) => {
            let dd = {
              eur : ' €', 
              usd : ' $', 
              krw : ' 원', 
            }
            return this.$options.filters.title(data.value)
          }},
          {headerName: '출금신청번호(W-No.)',      field: 'ref_code',     filter: false,width: 200},
          {headerName: 'Action',      field: '',  pinned: 'right',   filter: false,width: 200,
            cellRendererParams: {
              clicked: function(data) {
                this.context.componentParent.setPayment(data)
                //this.context.componentParent.closeModal('licensor')
              },
              clicked2: function(data) {
                this.context.componentParent.setReject(data)
                //this.context.componentParent.closeModal('licensor')
              }
            },
            cellRendererSelector: (data) => {
              
                if(data.data.state == 'rejected'){
                  return { 
                    component: 'tooltip',
                    params: {
                      ...data.data,
                      text: data.data.rejected_reason,
                      title : '반려'
                    }
                  }
                }else if( data.data.state == 'fulfilled'){
                  return { 
                    component: 'textRender',
                    params: {
                      ...data.data,
                      text: this.fixDate(data.data.fulfillment_timestamp)
                    }
                  }
                }else{
                  return { 
                    component: 'multiSelect',
                    params: {
                      ...data.data,
                    }
                  }
                }
            }
          },
      ],
      tableData:[
      ],



      invoiceData : {},
      invoiceDate : null,
      selectData : {},
      reason :null,

      settlement : {
        startDate :null,
        endDate : null,
        type : '',
        typeOption : [
          {value: '' , label : "전체"},
          {value: 'individual' , label : "개인"},
          {value: 'corporation' , label : "사업자"}
        ]
      },

      summary: null,
    }
  },
  created(){
    if(this.$route.query.page){
        this.page.currentPage= Number(this.$route.query.page)
    }
    if(this.$route.query.keywordType){
        this.keywordType= this.$route.query.keywordType
    }
    if(this.$route.query.keyword){
        this.keyword= this.$route.query.keyword
    }
    if(this.$route.query.role){
        this.role= this.$route.query.role
    }
    if(this.$route.query.entity){
        this.entity= this.$route.query.entity
    }
    if(this.$route.query.currency){
        this.currency= this.$route.query.currency
    }
    if(this.$route.query.payment_method){
        this.payment_method= this.$route.query.payment_method
    }
    if(this.$route.query.date_start && this.$route.query.date_end){
        this.dateType= this.$route.query.date_field
        this.startDate= this.$route.query.date_start
        this.endDate= this.$route.query.date_end
    }
    if(this.$route.query.entity_tax_exemption){
        this.entity_tax_exemption= this.$route.query.entity_tax_exemption
    }
    
  },
  mounted(){
    this.$nextTick(() =>{
      this.callList()
    })
  },
  computed: {
    summaryDisplay() {
      if (!this.summary) return []
      const currencies = [
        { key: 'krw', label: 'KRW', prefix: '', suffix: '원', colorHex: '#7367f0' },
        { key: 'usd', label: 'USD', prefix: '$', suffix: '', colorHex: '#28c76f' },
        { key: 'eur', label: 'EUR', prefix: '€', suffix: '', colorHex: '#ff9f43' },
      ]
      return currencies.map(({ key, label, prefix, suffix, colorHex }) => ({
        label,
        prefix,
        suffix,
        colorHex,
        requested: this.summary[key].requested,
      }))
    },
  },
  watch: {
    'page.currentPage'(e){
        
        this.callList()
    },
    'page.pageSize'(){
        this.list_search()
    }
  },
  methods: {
    processDataFromClipboard(params) {
       console.log(params)
    },

    callSummary() {
      const option = {}
      if (!this.valCheck(this.state)) option['state'] = this.state
      if (!this.valCheck(this.currency)) option['user_currency'] = this.currency
      if (!this.valCheck(this.dateType) && !this.valCheck(this.startDate) && !this.valCheck(this.endDate)) {
        option['date_field'] = this.dateType
        option['date_start'] = this.startDate
        option['date_end'] = this.endDate
      }
      this.$store.dispatch('GET_WITHDRAWAL_SUMMARY', option)
        .then(result => { this.summary = result })
        .catch(() => { this.summary = null })
    },

    resetSearch (){
      this.page.currentPage = 1
      this.keyword = null
      this.keywordType = null
      this.dateType = 'created_at'
      this.startDate = null 
      this.endDate = null 
      this.state = null
      this.role = null
      this.currency = null
      this.entity = null
      this.payment_method = null
      this.entity_tax_exemption = null
      this.callList() 
    },
    callList(){
        this.loadingShow();
        this.callSummary()
        const option = {
            sort: 'created_at',
            sortorder: 'desc',
            page: this.page.currentPage-1 ,
            limit: this.page.pageSize,

        }
        let query = {}
        if(this.page.currentPage != 1){
          query['page'] = this.page.currentPage
        }
        if(this.keywordType && this.keywordType != '') {
            option[this.keywordType] = this.keyword
            query['keywordType'] = this.keywordType
            query['keyword'] = this.keyword
        }
        if(!this.valCheck(this.dateType) && !this.valCheck(this.startDate )&& !this.valCheck(this.endDate) ){
            option['date_field'] = this.dateType
            option['date_start'] = this.startDate
            option['date_end'] = this.endDate

            query['date_field'] = this.dateType
            query['date_start'] = this.startDate
            query['date_end'] = this.endDate
        }
        if(!this.valCheck(this.state)){
          option['state'] = this.state
          query['state'] = this.state
        }
        if(!this.valCheck(this.role)){
          option['user_role'] = this.role
          query['role'] = this.role
        }
        if(!this.valCheck(this.payment_method)){
          option['user_payment_method'] = this.payment_method
          query['payment_method'] = this.payment_method
        }
        if(!this.valCheck(this.currency)){
          option['user_currency'] = this.currency
          query['currency'] = this.currency
        }
        if(!this.valCheck(this.entity)){
          option['user_entity'] = this.entity
          query['entity'] = this.entity
        }
        if(!this.valCheck(this.entity_tax_exemption)){
          option['entity_tax_exemption'] = this.entity_tax_exemption
          query['entity_tax_exemption'] = this.entity_tax_exemption
        }
        this.$router.replace({query: query}).catch((e)=>{});
        this.loadingShow();
        this.$store.dispatch('GETWITHDRAWAL', option)
        .then(result =>{
            this.loadingHide();
            this.tableData  = result.items // 권리자 목록
            
            this.total = result.total // 총인원수 
            this.filtered = result.filtered // limit에 따른 수
            //페이지 수
            const remainder = parseInt(this.filtered % this.page.pageSize) > 0? 1: 0
            this.page.totalPage = parseInt(this.filtered/this.page.pageSize) + remainder
        }).catch(error=>{
            const status = error.status
            this.loadingHide();
            
            switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
                this.alert({msg:error.response.data.message})
              break;
            }
        })
    },
    
    list_search(){
      this.page.currentPage = 1  // 초기화
      this.callList()
    },
    
    setInvoice(data){
      console.log(data);
      this.invoiceData = data
      this.invoiceDate = null
      this.openModal('invoice')

      // 
      
    },
    postInvoice(){
      
        if( this.valCheck(this.invoiceDate)){
          this.alert({msg:'발행일을 선택해주세요.'})
          return false
        }
      
      
      let payload ={
        id : this.invoiceData.user_id,
        withdrawal_id : this.invoiceData.id,
        params : {
          processing_date : this.invoiceDate
        }
      }
      this.$store.dispatch('PUT_TAX_INVOICE_DATE', payload)
      .then(result =>{
          this.loadingHide();
          this.invoiceData  = {} // 권리자 목록
          this.invoiceDate = null
          this.closeModal('invoice')
          this.noti('발행일이 등록되었습니다.');
          this.callList()
      }).catch(error=>{
          const status = error.status
          switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
                this.alert({msg:error.response.data.message})
              break;
          }
      })
    },
    setReject(data){
      this.selectData = data
      this.openModal('reject')
    },
    postReject(){
      if(this.valCheck(this.reason)){
        this.alert({msg:'반려사유를 입력해주세요.'})
        return false
      }
      let payload ={
        id : this.selectData.user_id,
        withdrawal_id : this.selectData.id,
        params : {
          reason : this.reason
        }
      }
      this.$store.dispatch('REJECT_WITHDRAWAL', payload)
      .then(result =>{
          this.loadingHide();
          this.closeModal('reject')
          this.noti('반려처리 되었습니다.');
          this.callList()
      }).catch(error=>{
          const status = error.status
          switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
                if(error.response.data.message == "ACCESS_VIOLATION: Only @Bella can reject!"){
                  this.alert({msg:'권한이 없습니다.'})
                }else{
                  this.alert({msg:error.response.data.message})
                }
              break;
          }
      })
    },
    setPayment(data){
      console.log(data)
      if(data.user_entity != 'individual' ){
        if(data.tax_invoice_checked){
          this.selectData = data
          this.openModal('payment')
        }else {
          this.alert({msg:'발행일 등록을 진행해주세요.'})
        }
      }else{
        if(data.user_country.toLowerCase()  != 'kr'){
          if(data.tax_invoice_checked){
            this.selectData = data
            this.openModal('payment')
          }else {
            this.alert({msg:'발행일 등록을 진행해주세요.'})
          } 
        }else{
          this.selectData = data
          this.openModal('payment')
        }
        
      }
      
      
    },
    postPayment(){
      let payload ={
        id : this.selectData.user_id,
        withdrawal_id : this.selectData.id,
        params : {
          
        }
      }
      
      this.$store.dispatch('FULFILL_WITHDRAWAL_REQUEST', payload)
      .then(result =>{
          this.loadingHide();
          this.closeModal('payment')
          this.noti('지급처리가 완료되었습니다.');
          this.callList()
      }).catch(error=>{
          const status = error.status
          switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
              if(error.response.data.message == "ACCESS_VIOLATION: Only @Bella can reject!"){
                this.alert({msg:'권한이 없습니다.'})
              }else{
                this.alert({msg:error.response.data.message})
              }
            break;
          }
      })
    },
    getExcelFile(response){
      let filename = "",
          disposition = response.headers["content-disposition"];
        
      if (disposition && disposition.indexOf("attachment") !== -1) {
          let filenameRegex = /filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/, matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
          }
      }

      if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
          window.navigator.msSaveOrOpenBlob(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
              filename);
      } else {
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
      }
    },
    getExcel(){
        const option = {
        }
        let query = {}
        if(this.keywordType && !this.valCheck(this.keyword)) {
            option[this.keywordType.value] = this.keyword
        }
        if(!this.valCheck(this.dateType) && !this.valCheck(this.startDate )&& !this.valCheck(this.endDate) ){
            option['date_start'] = this.startDate
            option['date_end'] = this.endDate
        }
        if(!this.valCheck(this.state)){
          option['state'] = this.state
        }
        if(!this.valCheck(this.role)){
          option['user_role'] = this.role
        }
        if(!this.valCheck(this.payment_method)){
          option['user_payment_method'] = this.payment_method
        }
        if(!this.valCheck(this.currency)){
          option['user_currency'] = this.currency
        }
        if(!this.valCheck(this.entity)){
          option['user_entity'] = this.entity
        }

        if(Object.keys(option).length == 0){
          this.alert({msg:'한가지 이상의 검색 조건을 입력해주세요.'});
          return false;
        }
        this.loadingShow();
        this.$store.dispatch('GET_WITHDRAWAL_EXCEL', option)
        .then(result =>{
            this.loadingHide();
            console.log('result',result)
            this.getExcelFile(result)
        }).catch(error=>{
          this.loadingHide();
          const status = error.status
          switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
              this.alert({msg:error.response.data.message})
            break;
          }
        })
      
    },
    openSettlement(){
        
        this.settlement.startDate = null
        this.settlement.endDate = null
        this.settlement.type = ''
        this.openModal('settlement')
    },
    getSettlement(){
        let option ={}
        if(!this.valCheck(this.settlement.startDate )&& !this.valCheck(this.settlement.endDate) ){
            option['date_start'] = this.settlement.startDate
            option['date_end'] = this.settlement.endDate
        }
        if(!this.valCheck(this.settlement.type )){
            option['user_entity'] = this.settlement.type
        }
        if(Object.keys(option).length == 0){
          this.alert({msg:'기간을 입력해주세요.'});
          return false;
        }
        this.loadingShow();
        this.$store.dispatch('GET_SETTLEMENT_EXCEL', option)
        .then(result =>{
            this.loadingHide();
            this.getExcelFile(result)
        }).catch(error=>{
            this.loadingHide();
            const status = error.status
            switch(status){
                case 4:
                this.alert({msg:'조회된 데이터가 없습니다. 기간을 확인해주세요.'})
                break;
                case 401:
                this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                break;
                default:
                break;
            }
        })
    }
  }
}
</script>

<style scoped>

</style>
